import Button from '../ui/Button.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const Day = ({ ...props }) => {
    const { heading, subheading, image, text, button, fn } = props;

    return (
        <div className="component-message">
            <div className="row justify-center">
                <div className="col lg:w-8/12 xl:w-6/12">
                    <div className="text-center">
                        <HeadingOne heading={heading} />
                        <img src={image} className="mx-auto" />
                        <h2 className="mt-12">{subheading}</h2>
                        <div dangerouslySetInnerHTML={{ __html: text }}></div>

                        <div className="mt-12">
                            <Button {...button} onClick={fn.handleButton(button.action)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Day;
